import { CEMC_ConvertToNormalEvent, CEMC_SpecialiseEvent } from '../metamodel';
import { ensureEvent } from '../metamodel/util';
import { makeOETRootRow, makeOETSubRow } from '../uimodel';
import type { IModel, OrId } from '../types';
import type { IEventType } from '../../../stores/model/metamodel/event_type';
import type { IInheritance } from '../../../stores/model/metamodel/inheritance';

/**
 * Convert an event type to a specialised event.
 *
 * @param {Model} model The model to operate on.
 * @param {EventType or String} eventOrId The event or its id.
 * @param {EventType or String} ownerEventTypeOrId: the new owner event type or its id.
 * @param {Inheritance or String} inheritanceOrId: the new inheritance or its id.
 */
export function Combined_SpecialiseEvent(
  model: IModel,
  eventOrId: OrId<IEventType>,
  ownerEventTypeOrId: OrId<IEventType>,
  inheritanceOrId: OrId<IInheritance>
) {
  const result = CEMC_SpecialiseEvent(model, eventOrId, ownerEventTypeOrId, inheritanceOrId);
  makeOETSubRow(model.uimodel, result.event);
  return result;
}

/**
 * Convert a specialised event type to a normal event.
 *
 * @param {Model} model The model to operate on.
 * @param {EventType or String} eventOrId The event or its id.
 */
export function Combined_ConvertToNormalEvent(model: IModel, eventOrId: OrId<IEventType>) {
  const event = ensureEvent(model.metamodel, eventOrId)!;
  // Move the OET subrow to the root
  // We cannot remove/append here, since we would lose the subrows in case the event
  makeOETRootRow(model.uimodel, event);
  return CEMC_ConvertToNormalEvent(model, event);
}
